import MyNeedAside from "./components/MyNeedAside.vue";
import TableTab from "./components/TableTab.vue";
import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue';
export default defineComponent({
  components: {
    MyNeedAside,
    TableTab
  },
  setup(props, ctx) {
    const asideRef = ref(null);
    let data = reactive({
      activeTab: 'all'
    });
    const asideRefresh = () => {
      asideRef.value.refresh();
    };
    return {
      ...toRefs(data),
      asideRef,
      asideRefresh
    };
  }
});